/* eslint-disable no-unused-vars */
export default {
  install(Vue, options = {}) {
    Vue.prototype.$loading = {
      show: () => {
        if (options.store) {
          options.store.dispatch('LOADING', true)
        }
      },
      hide: () => {
        if (options.store) {
          options.store.dispatch('LOADING', false)
        }
      }
    }
  }
}